import React from 'react';
import { Input } from 'semantic-ui-react';
import { formatToBEDatetime } from '../../utils';
import moment from 'moment';
import { useIntl } from "react-intl";

interface TimeFreeTextBoxProps {
 disabled?: boolean;
 onChange?: () => void;
 value?: string;
 className?: string;
 disabledClick?: boolean;
}

const DEFAULT_PROPS = {
  disabled: false,
  onChange: () => {},
  value: '',
  className: '',
  disabledClick: false,
}
const TimeFreeTextBox = React.forwardRef<any,TimeFreeTextBoxProps> ((propsParam, ref) => {

  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }

  const [time, setTime] = React.useState('')

  React.useEffect(() => {
    setTime(props.value)
  }, [props.value])

  React.useImperativeHandle(ref, () => ({
    getTime: () => {
      return time
    }
  }))

  const timeChange = (e: any) => {
    const { value } = e.target;
    setTime(value)
    props.onChange(value)
  }

  const setCurrentTime = () => {
    if (!props.disabledClick) {
      let dateTime = formatToBEDatetime({ date: moment() })
      let time = dateTime.split(' ')[1]
      setTime(time)
      props.onChange(time)
    } else {
      if (!time) {
        let dateTime = formatToBEDatetime({ date: moment() })
        let time = dateTime.split(' ')[1]
        setTime(time)
        props.onChange(time)
      }
    }
  }

  return (
    <Input
      disabled={props.disabled ? true : false}
      type='time'
      name="time"
      value={time}
      onChange={timeChange}
      icon='clock'
      className={props.className}
      onClick={setCurrentTime }
    />
  )
})

TimeFreeTextBox.displayName = "TimeFreeTextBox"

export default React.memo(TimeFreeTextBox)

